import React, { useEffect } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import { createDefaultConfig } from './cookieConsentConfigs';

const handleManageCookiesLink = (event: React.MouseEvent<HTMLButtonElement>) => {
  event.preventDefault();
  CookieConsent.reset(true);
  CookieConsent.run(createDefaultConfig());
  CookieConsent.show(true);
};


const Footer: React.FC = () => {
  useEffect(() => {
    CookieConsent.run(
      createDefaultConfig()
    );
  }, []);


  return (
  <div id="footer-placeholder">

    <div className="footer">
      <p>
        © 2025 <a href="https://debuginthewoods.net/" target="_blank" rel="noreferrer"> Debug In The Woods</a> 
      </p>
      <p>
        Help us make this website better. Share your thoughts on <a target="_blank" href="https://x.com/junaokidev" rel="noreferrer">X</a> 
      </p>
      <p>
        <strong>Disclaimer:</strong> 
        This application suite is provided "as is" without any warranty. It may collect user data. By using this suite, you agree to the <a target="_blank" href="/privacy.html">Privacy Policy</a> 
        and <a target="_blank" href="/terms.html">User Agreement</a>.
      </p>

      <button 
        id="manageCookies" 
        onClick={handleManageCookiesLink}
      >
        Manage Cookies
      </button>

    </div>

  </div>

  );
}

export default Footer;